import { useCallback } from 'react'

import { decomposition, getDishMasterContract, getSoccerPokerGameBoxMasterContract } from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'

import { NFTTYPE } from '../../constants/bakery/nft'


const useDecomposition = (tokenId: string, type?: string) => {
  const {account} = useActiveWeb3React()
  const sushi = useYam()
  let dishMasterContract = getDishMasterContract(sushi)

  switch (type) {
    case NFTTYPE.GAMEBOX:
      dishMasterContract = getSoccerPokerGameBoxMasterContract(sushi)
      break;
  }

  const handleDecomposition = useCallback(async () => {
    try {
      const txHash = await decomposition(
        dishMasterContract,
        tokenId,
        account
      )
      console.log(txHash)
      return txHash
    } catch (e) {
      return false
    }
  },
  [account, tokenId, dishMasterContract])

  return { onDecomposition: handleDecomposition }
}

export default useDecomposition
